import { useEffect, useState } from "react"
import { Search, Filter, Mail, Link2 } from "lucide-react"

import CommunityBanner from "./CommunityBanner"
import { useCommunity } from "../../context/CommunityContext";
const roles = ["All Members", "Moderators", "Contributors", "New Members"]

export function CommunityMembersPage() {

  const communityCtx = useCommunity();
  const [selectedRole, setSelectedRole] = useState("All Members")
  const [sortBy, setSortBy] = useState("recent")
  const [members, setMembers] = useState([])

  useEffect(() => {
    setMembers(communityCtx.members.data.members)
  }, [communityCtx.members.data])

  return (
    <div className="space-y-6 max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8">
      <CommunityBanner />

      {/* Search and Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="search"
            placeholder="Search members..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
        <div className="flex gap-2">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <option value="recent">Recently Joined</option>
            <option value="reputation">Highest Reputation</option>
            <option value="contributions">Most Contributions</option>
          </select>
          <button className="inline-flex items-center px-4 py-2 bg-white  border border-gray-200  rounded-lg hover:bg-gray-50  transition-colors">
            <Filter className="w-5 h-5 mr-2" />
            Filters
          </button>
        </div>
      </div>

      {/* Roles Filter */}
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-2 px-2 scrollbar-hide">
        {roles.map((role) => (
          <button
            key={role}
            onClick={() => setSelectedRole(role)}
            className={`
                flex items-center px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors
                ${selectedRole === role
                ? "bg-indigo-600 text-white"
                : "bg-white  text-gray-700  hover:bg-gray-50 "
              }
              `}
          >
            {role}
          </button>
        ))}
      </div>

      {/* Members Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {members.map((member) => (
          <div
            key={member.id}
            className="bg-white  rounded-xl shadow-sm hover:shadow-lg transition-shadow"
          >
            {/* Member Header */}
            <div className="p-6 border-b border-gray-200 ">
              <div className="flex items-start gap-4">
                <img
                  src={member.profilePicture || "/placeholder.svg"}
                  alt={member.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold truncate">{member.name}</h3>
                  </div>
                  <p className="text-sm text-gray-500">{member.role}</p>
                  <p className="text-sm text-gray-500">Joined {member.joinDate}</p>
                </div>
              </div>
            </div>

            {/* Member Bio */}
            <div className="p-6 border-b border-gray-200 ">
              <p className="text-sm text-gray-600  line-clamp-2">{member.bio}</p>
            </div>

            {/* Member Stats */}
            <div className="px-6 py-4 border-b border-gray-200 ">
              <div className="flex items-center justify-around text-sm">
                <div className="text-center">
                  <span className="block font-semibold">{member.contributions}</span>
                  <span className="text-gray-500">contributions</span>
                </div>
                <div className="text-center">
                  <span className="block font-semibold">{member.reputation}</span>
                  <span className="text-gray-500">reputation</span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="p-4 flex flex-col sm:flex-row items-stretch gap-2">
              <button className="flex items-center justify-center gap-2 px-3 py-2 bg-indigo-50  text-indigo-600  rounded-lg hover:bg-indigo-100  transition-colors text-sm font-medium">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">Message</span>
              </button>
              <button className="flex items-center justify-center gap-2 px-3 py-2 bg-gray-50  text-gray-700  rounded-lg hover:bg-gray-100  transition-colors text-sm font-medium">
                <Link2 className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">Profile</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

